import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from '../components/Sidebar'
import { AppHeader } from '../components/AppHeader'

export default function AgentTVLayout() {
  const [isFull, setIsFull] = useState(true)
  const [sidebarOpen, setSidebarOpen] = useState(false)

  if (isFull) {
    return (
      <div className='min-h-screen'>
        <Outlet
          context={{ isFullScreen: true, toggle: () => setIsFull(false) }}
        />
      </div>
    )
  }

  return (
    <>
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      <AppHeader onOpenSidebar={() => setSidebarOpen(true)} />
      <div className='mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8'>
        <Outlet
          context={{ isFullScreen: false, toggle: () => setIsFull(true) }}
        />
      </div>
    </>
  )
}
